import theme from './PagePreviewTheme.js';

const getParents = (elem, setElementPath) => {
  let parents = "";

  for (; elem && elem !== document; elem = elem.parentNode) {
    const tagName = elem.tagName ? elem.tagName.toLowerCase() : 'document';
    if (tagName !== "body" && tagName !== "html" && tagName !== "document") {
      const _class = elem.className ? `.${elem.className.trim().replace(/ /g, '.')}` : '';
      const id = elem.getAttribute('id') ? `#${elem.getAttribute('id')}` : '';
      parents = `${tagName}${id}${_class} ${parents === "" ? "" : ">"} ${parents}`;
    }
  }
  setElementPath(parents);

  return parents;
};

const getTag = (matches, i = 0) => {
  if (matches) {
    const tag = matches[i];
    if (tag.indexOf("<%") === -1 && tag !== "<!--") {
      return tag;
    } else {
      i++;
      if (i < matches.length) {
        return getTag(matches, i);
      } else {
        return null;
      }
    }
  } else {
    return null;
  }
}

const cleanCode = (text) => {
  let pageCode = "";

  const rows = text.split('\n');
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];

    const matches = row.match(/<[^/][^ >]*/g);
    const tag = getTag(matches);
    pageCode += tag ? row.replace(tag, `${tag} pp_line="${i}"`) : row;
  }

  text = pageCode.replace(/<%([\S\s]*?)%>/g, '');

  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(text, 'text/html');
  const scripts = htmlDoc.documentElement.getElementsByTagName('script');
  let i = scripts.length;
  while (i--) {
    scripts[i].parentNode.removeChild(scripts[i]);
  }

  return theme + htmlDoc.documentElement.innerHTML;
}

const init = (e, editor, code, setElementPath) => {
  const goToLine = (e) => {
    e.preventDefault();
    e.stopPropagation();

    getParents(e.currentTarget, setElementPath)

    for (const input of inputs) {
      input.removeAttribute("pp_active");
    }

    let pageCode = code;
    const rows = pageCode.split('\n');
    const elementCode = e.currentTarget.outerHTML.split('\n')[0].replace(/  +/g, ' ').replace(/&amp;/g, '&').replace(/'/g, '"').replace(/ "/g, '"').replace(/×/g, '&times;').replace(/> /g, '>');

    e.currentTarget.setAttribute("pp_active", true);

    let lineNumber = 0;
    let column = 0;
    for (let i = 0; i < rows.length; i++) {
      let row = rows[i].replace(/<%([\S\s]*?)%>/g, '').replace(/  +/g, ' ').replace(/&amp;/g, '&').replace(/'/g, '"').replace(/ "/g, '"').replace(/ >/, '>').replace(/> /g, '>');

      const tag = row.match(/<[^/][^ >]*/g);
      if (tag) {
        if (tag[0].indexOf("<%") === -1 && tag[0] !== "<!--") {
          row = row.replace(tag[0], `${tag[0]} pp_line="${i}"`);
        }
      }

      if (row.indexOf(elementCode) > -1) {
        lineNumber = i + 1;
        column = row.indexOf(elementCode) + 1;
      }
    }

    if (lineNumber > 1) {
      editor.focus();
      editor.revealLineInCenter(lineNumber + 15);
      editor.setPosition({ column, lineNumber });
    }
  }

  const inputs = e.currentTarget.contentWindow.document.querySelectorAll('*');

  for (const input of inputs) {
    const tagName = input.tagName ? input.tagName.toLowerCase() : 'document';
    if (tagName !== "body" && tagName !== "html" && tagName !== "document") {
      input.onclick = goToLine;
      input.onmousedown = e => e.preventDefault();
      input.onmouseup = e => e.preventDefault();
    }
  }
}

const PagePreview = {init, cleanCode}

export default PagePreview;